import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_fragrances_sprays: FaireCategoryEntity = {
  token: "cat_fragrances-sprays",
  type: "category",
  name: "Room sprays & sachets",
  level: 3,
  parentToken: "cat_home-decor-fragrances",
  href: "/category/home-decor/home-fragrances/room-sprays-sachets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
